import { render } from "./AlipayCouponsTable.vue?vue&type=template&id=cb25e510&scoped=true"
import script from "./AlipayCouponsTable.vue?vue&type=script&lang=js"
export * from "./AlipayCouponsTable.vue?vue&type=script&lang=js"

import "./AlipayCouponsTable.vue?vue&type=style&index=0&id=cb25e510&lang=scss"
import "./AlipayCouponsTable.vue?vue&type=style&index=1&id=cb25e510&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb25e510"]])

export default __exports__